<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }} 
      <v-btn color="pink" text  @click="msg = false"> Close</v-btn>
    </v-snackbar>

    <StaffNav class="hideOnPrint"/>

    <v-row dense>
       <v-col cols="12" lg="3" xl="2">
           <StaffSide />
       </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-data-table
          :headers="headers"
          :items="vehicles"
          sort-by="Date"
          sort-asc
          class="elevation-1 hideOnPrint"
          :loading="isLoading"
          loading-text="Loading Vehicle Maintenance Logs"
          :search="search"
          height="578"
        >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Maintenance Log</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="search"
            ></v-text-field>

            <v-spacer></v-spacer>
            <report-list-actions
              :reportOptions="reportOptions"
              :downloadFilename="reportListFilename"
            ></report-list-actions>

            <v-spacer></v-spacer>
            <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()">
              <v-icon left>add</v-icon>
              Add Maintenance
            </v-btn>
            
          </v-toolbar>

        </template>
        

       <template v-slot:item.actions="{ item }">        
    
        <v-icon small class="mr-2" @click="viewMaintenance(item._id)">
          mdi-eye
        </v-icon>

        <v-icon small @click="deleteMaintenance(item)">
          mdi-delete
        </v-icon>

      </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import axios from 'axios'
  import StaffNav from '@/components/StaffNav'
  import StaffSide from '@/components/StaffSide'
  import ReportListActions from '@/components/Report/ReportListActions.vue'

  const url = require("@/client_config/config").url;

  export default {
    components: {
      StaffNav,
      StaffSide,
      ReportListActions
    },
    data: function() {
      return {
        headers: [
          {
            text: 'Date',
            align: 'start',
            sortable: true,
            value: 'Date',
          },
          { text: "Vehicle", value: "Vehicle" },
          { text: "Service", value: "Service" },
          { text: "Next Service", value: "NextAppointment" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        msg: false,
        search: "",
        text:"",
        vehicles: [],
        isLoading: false,
        on: false,
        userState: localStorage.getItem('userState'),
        newVehicles: [],
        StaffID: this.$route.params.employeeID,
        
      }
    },

    created() {
      this.getVehicles();
      this.getMaintenances();
    },

    computed: {
      formTitle() {
        return this.editedIndex != 1 ? "New Item" : "Edit Item";
      },
      vehicleText() {
        return function (item) {
            // Concatenate the desired fields (e.g., Make, Model, Year)
            return `${item.Year} ${item.Make} ${item.Model}`;
        };
      },

      staffName() {
        // `this` points to the component instance
        return localStorage.getItem("Name");
      },

      selectedEmployee() {
        return this.$store.state.users.allUsers.find(
            (user) => user._id == this.StaffID
        )
      },

      employeeName() {
        return this.selectedEmployee?.Name ?? ""
      },

      reportOptions() {
        return { 
          query: {
            name: this.employeeName,
          },
          endpoints: `vehicleMaintenance/printList/${this.StaffID}`,
          dynamic: true
        }
      },
      reportListFilename() {
        return `${this.employeeName} - Vehicle Maintenance`
      },
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }
    },

    methods: {
      getVehicles() {
        this.isLoading = true;
        axios.get(`${url}/vehicles/active/${this.userState}`).then(res => {
            this.newVehicles = res.data.vehicles.map(vehicle => `${vehicle.Year + ' ' + vehicle.Make + ' ' + vehicle.Model}` )
                    .sort();

        }).finally(() => this.isLoading = false);
      },
      
      getMaintenances: function() {
        this.isLoading = true;
        axios.get(`${url}/vehicleMaintenance/staff/${this.StaffID}`).then(res => {
          this.vehicles = res.data.data;
        }).finally(() => this.isLoading = false);
      },
      
      viewMaintenance(id) {
        this.$router.push({
          path: `/VehicleMaintenance/${this.StaffID}/edit/${id}`,
        });
      },

      showAdd(){
        this.$router.push({
          path: `/VehicleMaintenance/${this.StaffID}/add/`,
        });
      },
      

      deleteMaintenance(item) {
        const id = item._id;
        confirm("Are you sure you want to delete this maintenance log?") &&
        this.maintenanceDelete(id);
      },

      maintenanceDelete(id) {
        axios.delete(`${url}/vehicleMaintenance/${id}`)
        .then((response) => {
          this.getMaintenances();
          if (response.status == 400) {
            response.json().then(function(data) {
              return data.msg;
            });
          }
          this.msg=true;
          this.text="The maintenance log has been deleted successfully.";
        });
      },
    }

  }
</script>